import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getUserSchoolProperty } from "../utils/utils";
import { ElementaryLevelsEnum, HemedElementaryLevelsEnum, HemedLevelsEnum, LevelsEnum } from "../enums/levelsEnum";

const useLevels = () => {

    const [levelsEnum, setLevelsEnum] = useState([]);
    const [levels, setLevels] = useState([]);
    const [currentLevel, setCurrentLevel] = useState(0);
    const { user, userDetails } = useSelector((state) => state.auth);
    const { methodica } = useSelector((state) => state.assessments);

    useEffect(() => {
        if (user && userDetails) {
            const isElementary = parseInt(user.studentkita, 10) <= (window.config.maxClassElemenatry || 0);
            let currentLevelsEnum = isElementary ? ElementaryLevelsEnum : LevelsEnum;
            const supervisionId = getUserSchoolProperty(userDetails, 'supervisionId');
            if (supervisionId === 2) {
                currentLevelsEnum = isElementary ? HemedElementaryLevelsEnum : HemedLevelsEnum;
            }
            const levels = Object.values(currentLevelsEnum);
            const completedAssessments = methodica?.filter((assessment) => assessment.complated) || [];
            const lastCompletedIndex = Math.min(completedAssessments.length - 1, levels.length - 1);
            setLevelsEnum(currentLevelsEnum);
            setLevels(levels)
            setCurrentLevel(levels[lastCompletedIndex]);
        }
    }, [user, userDetails, methodica]);

    let isChallengeCompleted = () => {
        return currentLevel === levelsEnum.PRO
    }

    return {
        levels: levels,
        levelsEnum: levelsEnum,
        currentLevel: currentLevel,
        isChallengeCompleted: isChallengeCompleted
    };
};

export default useLevels;
